module.exports = __webpack_public_path__ + "img/previous.d5cc9335.svg";